import { gql } from "@apollo/client";

export const GET_ESTADOS_HISTORIAL_EVOLUCION_ASISTENCIAL = gql`
query GetAllHistorialRIEstado {
  allHistorialRIEstado {
    idEstado
    nombre
  }
}`;